export const isMobile = process.env.PLATFORM === "mobile";
export const isDesktop = process.env.PLATFORM === "desktop";



// WEBPACK FOOTER //
// ./src/shared/util/EnvironmentHelpers.js